import { createSelector } from 'reselect';

import type { PoliciesState } from './slice';

/**
 * The selector for the `policies` state store slice
 */
export const getPoliciesSlice = (state: any): PoliciesState => state.Policies;

/**
 * The current list of policies
 */
export const selectPolicies = createSelector(
  getPoliciesSlice,
  ({ policies = [] }) => policies,
);
